module.exports = __webpack_public_path__ + "static/media/theme_gyser.104c1361.jpg";